module.exports = __webpack_public_path__ + "img/75725.cbf7c168.svg";